module.exports = __webpack_public_path__ + "static/media/img10.3bc0f1ae.png";